import axios from "axios";

import API_URLS from "constants/apis.url";
import { AXIOS_TIMEOUT } from "constants/globalConstants";

const APP_lOGIN_URL = process.env.REACT_APP_LOGIN_URL;
const OAUTH_TOKEN_URL = API_URLS.oAuthToken;

const axiosOauth = axios.create({ baseURL: APP_lOGIN_URL, timeout: AXIOS_TIMEOUT });

function postParamRequest(url, payload, params) {
  return axiosOauth.post(url, payload, { params }).then(response => response.data || response);
}

export const getToken = async params => await postParamRequest(OAUTH_TOKEN_URL, null, params);
